import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <path d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 16 12 C 16 14.220375 14.220375 16 12 16 L 12 18 C 15.301625 18 18 15.301625 18 12 L 16 12 z" />,
  'SphereOutlined'
);
